import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {

    const form = useRef();

    const sendEmail = (event) => {
        event.preventDefault();

        emailjs.sendForm('service_30aw8yl', 'template_p1a6at4', form.current, 'oEvbfDJ-hoKJB-6qV')
            .then((result) => {
                console.log(result.text);
                console.log('message sent');
            }, (error) => {
                console.log(error.text);
            });
    }

    return (
        <div>
            <h2 className="text-6xl text-center">Contact</h2>
            <div className="w-[1140px] mx-auto mt-5">
                <form ref={form} onSubmit={sendEmail} className="text-black">
                    <div className="form-control w-full mb-3">
                        <input type="text" name="user_name" placeholder="Name" className="input input-bordered w-full" />
                    </div>
                    <div className="form-control w-full mb-3">
                        <input type="email" name="user_email" placeholder="Email" className="input input-bordered w-full" />
                    </div>
                    <div className="form-control w-full mb-3">
                        <input type="text" name="subject" placeholder="Subject" className="input input-bordered w-full" />
                    </div>
                    <div className="form-control mb-3">
                        <textarea name="message" className="textarea textarea-bordered h-24" placeholder="Bio"></textarea>
                    </div>
                    <div className="form-control w-full">
                        <input type="submit" value="Submit" className="btn w-full" />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Contact;